import { v4 as uuidV4 } from 'uuid';

export const buildIdempotencyKey = (prefix: string) => `${prefix}-${uuidV4()}`;
